import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { jiraHorizontalNavEntrypoint } from '@atlassian/jira-horizontal-nav/entrypoint.tsx';
import { nextGenBacklogEntryPoint } from '@atlassian/jira-spa-apps-next-gen-backlog/entrypoint.tsx';

export const backlogPageEntrypoint = createPageEntryPoint({
	main: nextGenBacklogEntryPoint,
	topNavigationMenuId: MENU_ID.PROJECTS,
	horizontalNavigation: jiraHorizontalNavEntrypoint,
});
